import { ContactFormSelectOption } from '@/pages/LandingPage/sections/ContactUs/components/ContactFormSelect';

export const categoryOptions: ContactFormSelectOption[] = [
  {
    label: 'VC',
    value: 'VC',
  },
  {
    label: 'Protocol',
    value: 'Protocol',
  },
  {
    label: 'Fund',
    value: 'Fund',
  },
  {
    label: 'Institution',
    value: 'Institution',
  },
  {
    label: 'Asset Manager',
    value: 'Asset Manager',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];
